import styled from 'styled-components';
import { font } from 'app/shared/styles/_fontsize';

export const DescriptionText = styled.div`
  ${font.md};
`;
